"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.Delegate = void 0;
var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/for-each"));
var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/toConsumableArray"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));
var Delegate = exports.Delegate = /*#__PURE__*/function () {
  function Delegate() {
    var _this = this;
    (0, _classCallCheck2.default)(this, Delegate);
    (0, _defineProperty2.default)(this, "subscribers", []);
    (0, _defineProperty2.default)(this, "callAll", function (action) {
      var _context;
      (0, _forEach.default)(_context = _this.subscribers).call(_context, action);
    });
  }
  return (0, _createClass2.default)(Delegate, [{
    key: "subscribeObserver",
    value: function subscribeObserver(handlers) {
      var _context2;
      this.subscribers = (0, _concat.default)(_context2 = []).call(_context2, (0, _toConsumableArray2.default)(this.subscribers), [handlers]);
    }
  }, {
    key: "raiseEvent",
    value: function raiseEvent(eventName) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }
      this.callAll(function (handler) {
        var _handler$eventName, _context3;
        return (_handler$eventName = handler[eventName]) === null || _handler$eventName === void 0 ? void 0 : _handler$eventName.call.apply(_handler$eventName, (0, _concat.default)(_context3 = [handler]).call(_context3, args));
      });
    }
  }]);
}();
//# sourceMappingURL=Delegate.js.map